class Megamenu {
  constructor(container) {
    if (container.mobileMenuController) return container.mobileMenuController;
    container.mobileMenuController = this;
    this.mobileEvents = new AbortController();
    this.productCache = new Map();
    this.inFlightRequests = new Map();
    this.prefetchQueue = [];
    this.activeRequests = 0;
    this.idleCallbackId = null;
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;

    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      if (this.domNodes.hamburgerButtons.classList.contains("active")) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
      this.domNodes.hamburgerButtons.classList.toggle("active", this.open);
    }, { signal: this.mobileEvents.signal });
    this.domNodes.backDrop.addEventListener("click", (e) => {
      this.closeMenu();
    }, { signal: this.mobileEvents.signal });
    this.initMobileMegaMenu();
    this.initCollectionMenu();
    this.initDesktopMegaMenu();

    this.unsubscribeCart = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu(false);
    });
    this.unsubscribeSearch = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu(false);
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
      }
    });
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((item) => {
      const subMenuContainer = item.querySelector(".m-megamenu-mobile");
      const backBtn = item.querySelector(".m-menu-mobile__back-button");

      if (subMenuContainer) {
        subMenuContainer.inert = true;
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parentNode = e.target.parentNode;
            if (
              e.target.classList.contains("m-menu-mobile__back-button") ||
              parentNode.classList.contains("m-menu-mobile__back-button")
            ) {
              return;
            }

            this.openSubMenu(subMenuContainer, level);
          },
        });
      }

      if (backBtn) {
        backBtn.addEventListener("click", (e) => {
          const level = e.currentTarget.dataset.level;
          this.closeSubMenu(subMenuContainer, level);
        });
      }
    });

    const options = { signal: this.mobileEvents.signal };
    document.addEventListener("matchMobile", () => this.setMenuHeight(), options);
    document.addEventListener("unmatchMobile", () => this.setMenuHeight(), options);
  }

  initCollectionMenu() {
    const drawer = this.domNodes.menuDrawer;
    this.mobileMain = drawer.querySelector("[data-mobile-main]");
    this.collectionPanel = drawer.querySelector("[data-mobile-panel]");
    this.collectionBody = drawer.querySelector("[data-mobile-body]");
    drawer.querySelectorAll("[data-mobile-collection]").forEach((button) => { button.hidden = false; });
    drawer.addEventListener("click", (event) => {
      const control = event.target.closest("[data-mobile-collection], [data-mobile-back], [data-mobile-close]");
      if (!control || !this.open) return;
      if (control.hasAttribute("data-mobile-close")) this.closeMenu();
      else if (control.hasAttribute("data-mobile-back")) this.closeCollection();
      else this.openCollection(control);
    }, { signal: this.mobileEvents.signal });
    drawer.addEventListener("pointerdown", (event) => {
      const button = event.target.closest("[data-mobile-collection]");
      if (!button || !this.open) return;
      this.prioritizeCollection(button.dataset.collectionUrl);
    }, { signal: this.mobileEvents.signal, passive: true });
    drawer.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !this.open) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.collectionTrigger) this.closeCollection();
      else this.closeMenu();
    }, { signal: this.mobileEvents.signal });
    this.onMobileResize = () => {
      if (window.matchMedia("(min-width: 1024px)").matches) this.closeMenu(false);
      else this.setMenuHeight();
    };
  }

  getCollectionKey(rawUrl) {
    if (!rawUrl) return null;
    try {
      const parsed = new URL(rawUrl, window.location.origin);
      return parsed.pathname;
    } catch {
      return rawUrl;
    }
  }

  isCachedOrInFlight(collectionUrl) {
    const key = this.getCollectionKey(collectionUrl);
    if (!key) return true;
    return this.productCache.has(key) || this.inFlightRequests.has(key);
  }

  startPrefetch() {
    const drawer = this.domNodes.menuDrawer;
    const buttons = [...drawer.querySelectorAll("[data-mobile-collection]")];
    const urls = buttons
      .map((b) => b.dataset.collectionUrl)
      .filter((url) => Boolean(url) && !this.isCachedOrInFlight(url));

    for (const url of urls) {
      if (!this.prefetchQueue.includes(url)) {
        this.prefetchQueue.push(url);
      }
    }

    this.processPrefetchQueue();
  }

  scheduleNextPrefetch() {
    if (this.idleCallbackId || this.prefetchQueue.length === 0 || this.activeRequests >= 2) return;
    const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 100));
    this.idleCallbackId = schedule(() => {
      this.idleCallbackId = null;
      this.processPrefetchQueue();
    });
  }

  processPrefetchQueue() {
    while (this.activeRequests < 2 && this.prefetchQueue.length > 0) {
      const nextUrl = this.prefetchQueue.shift();
      if (!this.isCachedOrInFlight(nextUrl)) {
        this.fetchCollectionProducts(nextUrl).catch(() => {});
      }
    }
  }

  prioritizeCollection(collectionUrl) {
    const key = this.getCollectionKey(collectionUrl);
    if (!key || this.productCache.has(key) || this.inFlightRequests.has(key)) return;

    const idx = this.prefetchQueue.findIndex((u) => this.getCollectionKey(u) === key);
    if (idx > -1) {
      this.prefetchQueue.splice(idx, 1);
    }

    this.fetchCollectionProducts(collectionUrl).catch(() => {});
  }

  fetchCollectionProducts(collectionUrl) {
    const key = this.getCollectionKey(collectionUrl);
    if (!key) return Promise.reject(new Error("Invalid collection URL"));

    if (this.productCache.has(key)) {
      return Promise.resolve(this.productCache.get(key));
    }

    if (this.inFlightRequests.has(key)) {
      return this.inFlightRequests.get(key);
    }

    let url;
    try {
      url = new URL(collectionUrl, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error("Invalid collection origin");
    } catch (err) {
      return Promise.reject(err);
    }

    url.searchParams.set("section_id", "mobile-menu-products");
    this.activeRequests++;

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);

    const promise = fetch(url.href, { signal: controller.signal, credentials: "same-origin" })
      .then(async (response) => {
        if (!response.ok) throw new Error("Collection unavailable");
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const grid = doc.querySelector("[data-mobile-product-grid]");
        if (!grid) throw new Error("Products unavailable");
        return grid;
      })
      .then((grid) => {
        this.productCache.set(key, grid);
        return grid;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        clearTimeout(timeout);
        this.inFlightRequests.delete(key);
        this.activeRequests = Math.max(0, this.activeRequests - 1);
        this.scheduleNextPrefetch();
      });

    this.inFlightRequests.set(key, promise);
    return promise;
  }

  openCollection(button) {
    const template = document.getElementById(button.dataset.mobileCollection);
    if (!template || !this.open || window.matchMedia("(min-width: 1024px)").matches) return;
    this.collectionTrigger = button;

    const content = template.content.cloneNode(true);
    const target = content.querySelector("[data-mobile-products]");
    const collectionUrl = button.dataset.collectionUrl;
    const key = this.getCollectionKey(collectionUrl);

    if (target && key && this.productCache.has(key)) {
      const cachedGrid = this.productCache.get(key);
      const products = cachedGrid.cloneNode(true);
      const limit = Math.max(2, Math.min(6, Number(target.dataset.limit) || 4));
      [...products.children].slice(limit).forEach((card) => card.remove());
      target.replaceChildren(products);
      target.setAttribute("aria-busy", "false");
    }

    this.collectionBody.replaceChildren(content);
    this.collectionBody.scrollTop = 0;
    this.collectionPanel.querySelector("[data-mobile-title]").textContent = template.dataset.title;
    button.setAttribute("aria-expanded", "true");
    this.collectionPanel.inert = false;
    this.collectionPanel.classList.add("is-active");
    trapFocus(this.collectionPanel, this.collectionPanel.querySelector("[data-mobile-back]"), { preventScroll: true });
    this.mobileMain.inert = true;

    if (key && !this.productCache.has(key)) {
      this.loadCollectionProducts(collectionUrl, button);
    }
  }

  closeCollection(restoreFocus = true) {
    this.collectionPanel.classList.remove("is-active");
    this.mobileMain.inert = false;
    if (this.collectionTrigger) {
      this.collectionTrigger.setAttribute("aria-expanded", "false");
      if (restoreFocus) trapFocus(this.mobileMain, this.collectionTrigger, { preventScroll: true });
    }
    this.collectionPanel.inert = true;
    this.collectionTrigger = null;
  }

  async loadCollectionProducts(collectionUrl, triggerButton) {
    const target = this.collectionBody.querySelector("[data-mobile-products]");
    if (!target) return;

    try {
      const grid = await this.fetchCollectionProducts(collectionUrl);
      if (!target.isConnected || this.collectionTrigger !== triggerButton) return;
      const products = grid.cloneNode(true);
      const limit = Math.max(2, Math.min(6, Number(target.dataset.limit) || 4));
      [...products.children].slice(limit).forEach((card) => card.remove());
      target.replaceChildren(products);
    } catch (error) {
      if (target.isConnected && this.collectionTrigger === triggerButton) {
        const errorMsg = target.dataset.error || "Products could not load.";
        target.innerHTML = `<p class="m-mobile-discovery__error" role="status">${errorMsg}</p>`;
      }
    } finally {
      if (target.isConnected && this.collectionTrigger === triggerButton) {
        target.setAttribute("aria-busy", "false");
        trapFocus(this.collectionPanel, document.activeElement, { preventScroll: true });
      }
    }
  }

  destroyMobile() {
    if (this.open) this.closeMenu(false);
    this.mobileEvents.abort();
    if (this.idleCallbackId) {
      if (window.cancelIdleCallback) window.cancelIdleCallback(this.idleCallbackId);
      else clearTimeout(this.idleCallbackId);
      this.idleCallbackId = null;
    }
    this.prefetchQueue = [];
    this.inFlightRequests.clear();
    this.productCache.clear();
    this.unsubscribeCart?.();
    this.unsubscribeSearch?.();
    delete this.container.mobileMenuController;
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    if (window.matchMedia("(min-width: 1024px)").matches) return;
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.open = true;
    this.domNodes.menuDrawer.inert = false;
    this.domNodes.hamburgerButtons.setAttribute("aria-expanded", "true");
    trapFocus(this.mobileMain, this.mobileMain.querySelector("[data-mobile-close]"), { preventScroll: true });
    window.addEventListener("resize", this.onMobileResize);
    window.visualViewport?.addEventListener("resize", this.onMobileResize);
    this.startPrefetch();
  }

  closeMenu(restoreFocus = true) {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;
    this.closeCollection(false);
    removeTrapFocus(restoreFocus ? hamburgerButtons : null, { preventScroll: true });
    menuDrawer.inert = true;
    hamburgerButtons.setAttribute("aria-expanded", "false");
    window.removeEventListener("resize", this.onMobileResize);
    window.visualViewport?.removeEventListener("resize", this.onMobileResize);
    megaMenuMobile.forEach((container) => {
      container.classList.remove("open");
      container.inert = true;
    });
    menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
    menuDrawer.classList.remove("open");
    document.documentElement.classList.remove("prevent-scroll");
    this.domNodes.headerMobile.classList.remove("header-drawer-open");
    hamburgerButtons.classList.remove("active");
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");
    this.open = false;
  }

  openSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    subMenuContainer.classList.add("open");
    subMenuContainer.inert = false;
    trapFocus(subMenuContainer, subMenuContainer.querySelector(".m-menu-mobile__back-button"), { preventScroll: true });
  }

  closeSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    subMenuContainer.classList.remove("open");
    subMenuContainer.inert = true;
    const parentPanel = subMenuContainer.parentElement.closest(".m-megamenu-mobile");
    const focusArea = parentPanel || this.mobileMain;
    trapFocus(focusArea, subMenuContainer.parentElement.querySelector("a"), { preventScroll: true });
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const panelHeight = window.innerHeight - offsetBottom;

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
    menuDrawer.style.setProperty("--mobile-menu-top", `${Math.max(0, offsetBottom)}px`);
  }
}
class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.classList.contains("m-menu__item--mega")) return;

    clearTimeout(this.timeoutLeave);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(target);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;
        this.container && this.container.classList.add(this.classes.active);
        target.closest(".m-menu__item").classList.add("m-menu__item--active");
        // document.documentElement.classList.add("prevent-scroll");
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    this.activeIndex = -1;
    this.lastActiveIndex = index;
    evt.target.closest(".m-menu__item").classList.remove("m-menu__item--active");
    // document.documentElement.classList.remove("prevent-scroll");

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu(evt.target);
    }, 80);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };
}
